import { useCallback, useEffect, useMemo, useState } from 'react';
import shallow from 'zustand/shallow';
import { EPayMode } from '@root/constant';
import { paypalApi } from '@api';
import { useTranslation } from 'react-i18next';
import ImageCredit from '@root/assets/pay_credit.png';
import ImagePaypal from '@root/assets/pay_paypal.png';
import { usePayMethodState } from '@root/state';

export interface IPayMethodProps {
  methodList: {
    value: EPayMode;
    title: string;
    icon: string;
  }[];
  payMethod: EPayMode;
  onSelect: (v: any) => void;
}

const _DATA: any = {
  [EPayMode.PayPal]: {
    value: EPayMode.PayPal,
    titleKey: 'payPal',
    icon: ImagePaypal,
  },
  [EPayMode.CreditCard]: {
    value: EPayMode.CreditCard,
    titleKey: 'credit_card',
    icon: ImageCredit,
  },
};

const usePayMethod = (): IPayMethodProps => {
  const { t } = useTranslation();
  const [payMethod, setPayMethod] = useState<EPayMode>(EPayMode.PayPal);
  const { list, loaded, setList, setLoaded } = usePayMethodState(
    (state) => ({
      list: state.list,
      loaded: state.loaded,
      setLoaded: state.setLoaded,
      setList: state.setList,
    }),
    shallow,
  );

  const getPayMethodList = useCallback(() => {
    paypalApi.getPayMethodList().then((res: any) => {
      if (res?.length) {
        setList(res);
        setLoaded(true);
      }
    });
  }, [setList, setLoaded]);

  const methodList = useMemo(() => {
    return list
      .map((i) => {
        if (!_DATA[i.payMode]) {
          return null;
        }
        const { titleKey, ...rest } = _DATA[i.payMode];
        return {
          ...rest,
          title: t(titleKey),
        };
      })
      .filter(Boolean);
  }, [list, t]);

  const onSelect = useCallback((v: any) => {
    setPayMethod(v);
  }, []);

  useEffect(() => {
    if (!loaded) {
      getPayMethodList();
    }
  }, [getPayMethodList, loaded]);

  return { payMethod, methodList, onSelect };
};

export default usePayMethod;
